import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../components/Modal';
import Input from '../../../components/Input';
import {Button, buttonTypes} from '../../../components/Button';

class ChangePassword extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.changeUserPassword = this.changeUserPassword.bind(this);
    this.state = {
      currentPassword: '',
      newPassword: '',
      confirmNewPassword: '',
      error: {}
    }
  }

  static propTypes = {
    isOpenModalChangePassword: PropTypes.bool,
    toggleShowChangePasswordModal: PropTypes.func,
    changeUserPassword: PropTypes.func,
  };

  componentWillReceiveProps(next) {
    this.setState({error: next.error})
  }

  handleChange(e) {
    this.setState({[e.target.name]: e.target.value})
  }

  changeUserPassword() {
    const {
      currentPassword,
      newPassword,
      confirmNewPassword,
    } = this.state;
    const err = {};
    if (!currentPassword) err.currentPassword = 'Enter current password';
    if (!newPassword) err.newPassword = 'Enter new password';
    if (newPassword.length < 6) err.newPassword = 'Min length 6 characters';
    if (!confirmNewPassword) err.confirmNewPassword = 'Enter confirm password';
    if (newPassword !== confirmNewPassword) err.confirmNewPassword = 'Passwords do not match';
    if (Object.keys(err).length === 0)
      this.props.changeUserPassword({password: currentPassword, newPassword});
    this.setState({error: err})
  }

  render() {
    const {
      isOpenModalChangePassword,
      toggleShowChangePasswordModal,
    } = this.props;

    const {
      currentPassword,
      newPassword,
      confirmNewPassword,
      error
    } = this.state;

    return (
      <Modal
        classModal="authentication"
        isOpen={isOpenModalChangePassword}
        onRequestClose={toggleShowChangePasswordModal}
        showCloseIcon
        shouldCloseOnOverlayClick={false}
      >
        <div className="modal__wrap">
          <header>
            <h2 className="modal__title">Change Password</h2>
            <p className="modal__description">Fill all fields to change your password.</p>
          </header>
          <Input
            type="password"
            label="Current password"
            placeholder="Current password"
            value={currentPassword}
            name="currentPassword"
            error={error.currentPassword}
            onChange={this.handleChange}
          />
          <Input
            type="password"
            label="New password"
            placeholder="New password"
            value={newPassword}
            name="newPassword"
            error={error.newPassword}
            onChange={this.handleChange}
          />
          <Input
            type="password"
            label="Confirm password"
            placeholder="Confirm password"
            value={confirmNewPassword}
            name="confirmNewPassword"
            error={error.confirmNewPassword}
            onChange={this.handleChange}
          />
          <Button
            type={buttonTypes.AUTHENTICATION}
            name="Change My Password"
            onClick={this.changeUserPassword}
          />
        </div>
      </Modal>
    )
  }
}

export default ChangePassword;


// WEBPACK FOOTER //
// ./src/app/containers/Profile/components/ChangePasswordModal.js